import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=f3bf2f54&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=f3bf2f54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bf2f54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3bf2f54')) {
      api.createRecord('f3bf2f54', component.options)
    } else {
      api.reload('f3bf2f54', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=f3bf2f54&scoped=true&", function () {
      api.rerender('f3bf2f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2V55pcmypI443/JS/comp/PopupDialog.vue"
export default component.exports